import $ from 'jquery';
import PerformantEvents from './performant-events'

export default function init() {
    var $toc;
    var $stickyToc;
    var $body;
    var $tocLinks;
    var $stickyTocHeading;
    var $anchors;

    var $closeTocButton;
    var $openTocButton;
    var $closeStickyTocButton;
    var $openStickyTocButton;
    var $stickyTocTitle;
    var $tocList;
    var $stickyTocList;

    var $progressBar;
    var $publicationContent;

    var publicationContentOffset;
    var toggleStickyTocTitleVisibility;

    var $activeAnchor = false;
    var lastActiveHref = false;
    var hashDebounce = false;

    var intersectionObserver;
    var scrollingEnabled = true;
    var positionUpdatedAfterTocClose = true;

    var scrollingOffset = 100;
    var activeThreshold = 150;

    $toc = $('.js-toc');

    if ($toc.length <= 0) {
        return false;
    }

    $stickyToc = $('.js-toc-sticky');
    $body = $('body');
    $tocLinks = $('.js-toc-link');
    $stickyTocHeading = $('.js-toc-active-heading');
    $anchors = $('.js-toc-anchor');

    $closeTocButton = $('.js-toc-normal-close');
    $openTocButton = $('.js-toc-normal-open');
    $closeStickyTocButton = $('.js-toc-sticky-close');
    $openStickyTocButton = $('.js-toc-sticky-open');
    $stickyTocTitle = $('.js-toc-sticky-title');
    $tocList = $('.js-toc-list');
    $stickyTocList = $('.js-toc-sticky-list');

    $progressBar = $('.js-toc-progess');
    $publicationContent = $('.js-publication-content');

    publicationContentOffset = $publicationContent.offset().top;
    toggleStickyTocTitleVisibility = $stickyTocTitle.css('display') === 'none';

    intersectionObserver = new window.IntersectionObserver(updateStickyness, {rootMargin: getRootMargin()});
    intersectionObserver.observe($publicationContent[0]);

    PerformantEvents.onEvent('resize', refreshProgressBar);
    PerformantEvents.onEvent('resize', checkActiveNavItem);
    PerformantEvents.onEvent('resize', updateReadingProgress);

    PerformantEvents.onEvent('resizeVertical', refreshProgressBar);
    PerformantEvents.onEvent('resizeVertical', updateReadingProgress);

    PerformantEvents.onEvent('scroll', checkActiveNavItem);
    PerformantEvents.onEvent('scroll', updateReadingProgress);

    $tocLinks.on('click', navigateToAnchor);
    $openTocButton.on('click', function() { openToc('normal'); });
    $closeTocButton.on('click', function() { closeToc('normal'); });
    $openStickyTocButton.on('click', function() { openToc('sticky'); });
    $closeStickyTocButton.on('click', function() { closeToc('sticky'); });

    setTimeout(refreshProgressBar)

    function getRootMargin() {
        return '0px 0px -' + window.innerHeight + 'px 0px';
    }

    function refreshProgressBar() {
        publicationContentOffset = $publicationContent.offset().top;
        $progressBar.attr('max', $publicationContent.height());
    }

    function updateStickyness(entries) {
        if (!entries[0].isIntersecting) {
            $stickyToc.fadeOut(100).removeClass('state-visible');
        } else {
            $stickyToc.fadeIn(100).addClass('state-visible');
        }
    }

    function openToc(type) {
        var sticky = type === 'sticky' || false;
        var $toggle = $(this);
        var $currentToc = sticky ? $stickyToc : $toc;
        var $currentTocList = sticky ? $stickyTocList : $tocList;

        $currentToc.addClass('state-open');

        if (sticky) {
            if (toggleStickyTocTitleVisibility) {
                $stickyTocTitle.fadeIn('fast');
            }
            $currentTocList.fadeIn('fast', function() {
                disableScrolling($body);
                $(this).focus();

                $(document).on('keyup.closeToc', function(e) {
                    if (e.keyCode === 27) { // esc
                        closeToc('sticky');
                    }
                });
            });
        } else {
            $currentTocList.slideDown('fast', function() {
                $(this).focus();
            });
        }

        setTimeout(function() {
            $toggle.attr('aria-expanded', 'true');
        }, 200);
    }

    function closeToc(type) {
        var sticky = type === 'sticky' || false;
        var $toggle = $(this);

        var $currentToc = sticky ? $stickyToc : $toc;
        var $currentTocList = sticky ? $stickyTocList : $tocList;

        if (sticky) {
            if (toggleStickyTocTitleVisibility) {
                $stickyTocTitle.fadeOut('fast');
            }
            $currentTocList.fadeOut('fast', function() {
                enableScrolling($body);
                $('document').off('keyup.closeToc');
            });
        } else {
            $currentTocList.slideUp('fast');
        }

        setTimeout(function() {
            $toggle.attr('aria-expanded', 'false').delay(200).focus();
            $currentToc.removeClass('state-open');
        }, 200);

        positionUpdatedAfterTocClose = false;
    }

    function navigateToAnchor(e) {
        e.preventDefault();
        enableScrolling($body);
        var href = $(e.target).attr('href');
        var $anchor = $(href);
        var scrollTop = $anchor.offset().top - scrollingOffset;

        $('html, body').stop(true, false).animate({scrollTop: scrollTop}, 250, 'swing', closeToc('sticky'));

        $anchor.focus();
        if ($anchor.is(':focus')) {
            return !1;
        } else {
            $anchor.attr('tabindex', '-1');
            $anchor.focus();
        }
    }

    function updateReadingProgress() {
        var value = $(window).scrollTop() - publicationContentOffset;

        $progressBar.attr('value', value);
    }

    function checkActiveNavItem(position) {
        if (!scrollingEnabled) {
            return;
        }

        if (!positionUpdatedAfterTocClose) {
            position = $(window).scrollTop();
            positionUpdatedAfterTocClose = true;
        }

        var activePosition = position + activeThreshold;

        var $anchorsAboveThreshold = $anchors.filter(function (k, anchor) {
            return activePosition > $(anchor).offset().top;
        });

        if ($anchorsAboveThreshold.length === 0) {
            $activeAnchor = $anchors.first();
        } else {
            $activeAnchor = $anchorsAboveThreshold.last();
        }

        var href = '#' + $activeAnchor.attr('id');

        if (parseInt(position) === 0) {
            href = '';
        }

        if (lastActiveHref === href) {
            return;
        }

        lastActiveHref = href;

        var $activeNavLink = $tocLinks.filter('[href="' + href + '"]');

        $stickyTocHeading.text($activeNavLink.first().text());

        updateHashWithDebounce(href, 500);
    }

    function updateHashWithDebounce(href, debounceTime) {
        clearTimeout(hashDebounce);

        if (href === '') {
            history.replaceState('', document.title, window.location.pathname);
        } else {
            hashDebounce = setTimeout(function () {
                if (history.replaceState) {
                    history.replaceState(null, null, href);
                }
            }, debounceTime);
        }
    }

    function disableScrolling(target) {
        scrollingEnabled = false;
        $(target).addClass('stop-scrolling');
    }

    function enableScrolling(target) {
        $(target).removeClass('stop-scrolling');
        scrollingEnabled = true;
    }

    return {
        init: init,
    };
}
